<div class="flex flex-col items-center justify-center h-screen">
    <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '40px', height: '40px', color: 'var(--primary-color)' }" />
</div>
